module.exports = __webpack_public_path__ + "img/rouge-7.cf208949.png";